import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { applyTheme, readTheme } from "./lib/theme";
import "./styles.css";

// Before first paint, so a stored choice that differs from the OS setting
// never shows a frame of the wrong theme.
applyTheme(readTheme());

const el = document.getElementById("root");
if (!el) throw new Error("#root is missing from index.html");
createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
